export interface RowHeaderRow {
  key: string;
  header: React.ReactNode;
  value: React.ReactNode;
}

interface Props {
  rows: RowHeaderRow[];
}

export default function RowHeaderTable({ rows }: Props) {
  return (
    <table className='table gx-2 gs-0 mb-0'>
      <tbody>
        {rows.map((row) => (
          <tr key={row.key}>
            <td className='py-2 fw-bolder'>{row.header}</td>
            <td className='py-2'>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
